import { render, staticRenderFns } from "./HistoryRow_addressed.vue?vue&type=template&id=8260bb20"
import script from "./HistoryRow_addressed.vue?vue&type=script&lang=js"
export * from "./HistoryRow_addressed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports